






















































import Vue from 'vue';

import { breakpointsMixin } from '@/mixins/breakpoints';
import { iconsMixin } from '@/mixins/icons';

export default Vue.extend<any, any, any, any>({
    name: 'truck-quote-contact-information',
    mixins: [breakpointsMixin, iconsMixin],
    props: {
        value: {
            type: Object,
            required: true
        },
        showError: {
            type: Boolean,
            default: false
        },
        missingFields: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        contactInfo: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        isValidPhoneNumber(phone: string): boolean {
            const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
            return phoneRegex.test(phone);
        },
        isValidEmail(email: string): boolean {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        formatPhoneNumber(phone: string): string {
            const cleaned = phone.replace(/\D/g, '');
            if (cleaned.length !== 10) return phone;
            return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        },
        formatPhoneOnInput(event: Event) {
            const input = event.target as HTMLInputElement;
            if (input && input.value !== undefined) {
                const formatted = this.formatPhoneNumber(input.value);
                if (formatted !== input.value) {
                    this.contactInfo.phone = formatted;
                }
            }
        },
        validateBlock(): boolean {
            const missingFields: string[] = [];
            const c = this.value;
            if (!c.name) missingFields.push('Name');
            if (!c.company) missingFields.push('Company');
            if (!c.phone) missingFields.push('Phone');
            else if (!this.isValidPhoneNumber(c.phone)) missingFields.push('Phone (must be in format (XXX) XXX-XXXX)');
            if (!c.email) missingFields.push('Email');
            else if (!this.isValidEmail(c.email)) missingFields.push('Email (must be a valid email address)');
            this.$emit('update:missingFields', missingFields);
            this.$emit('update:showError', missingFields.length > 0);
            return missingFields.length === 0;
        }
    }
});
